export default __webpack_public_path__ + "static/media/NoSavedReport.8c6663fb.svg";